/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationStepsControllerUpdateMutationRequest, WorkflowApplicationStepsControllerUpdateMutationResponse, WorkflowApplicationStepsControllerUpdatePathParams, WorkflowApplicationStepsControllerUpdate400, WorkflowApplicationStepsControllerUpdate401, WorkflowApplicationStepsControllerUpdate403, WorkflowApplicationStepsControllerUpdate404 } from "../../models/workflowsController/WorkflowApplicationStepsControllerUpdate";

function getWorkflowApplicationStepsControllerUpdateUrl(id: WorkflowApplicationStepsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/workflow-application-steps/${id}` as const }  
  return res
}

/**
 * @summary Update a workflow application step (status override, field edit, reassign, or reorder)
 * {@link /api/v1/workflow-application-steps/:id}
 */
export async function workflowApplicationStepsControllerUpdate(id: WorkflowApplicationStepsControllerUpdatePathParams["id"], data?: WorkflowApplicationStepsControllerUpdateMutationRequest, config: Partial<RequestConfig<WorkflowApplicationStepsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowApplicationStepsControllerUpdateMutationResponse, ResponseErrorConfig<WorkflowApplicationStepsControllerUpdate400 | WorkflowApplicationStepsControllerUpdate401 | WorkflowApplicationStepsControllerUpdate403 | WorkflowApplicationStepsControllerUpdate404>, WorkflowApplicationStepsControllerUpdateMutationRequest>({ method : "PATCH", url : getWorkflowApplicationStepsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}